const React = require('react');

const LegalPageLayout = require('layouts/LegalPageLayout');
const TosContents = require('components/TosContents');
const { default: Classes } = require('./styles.scss');

module.exports = class TermsOfService extends React.PureComponent {

    render() {

        return (
            <LegalPageLayout>
                <TosContents className={Classes.legalContents} />
            </LegalPageLayout>
        );
    }
};
